





































































import Popper from "popper.js";
import {
  computed,
  defineComponent,
  nextTick,
  ref,
  watch
} from "@vue/composition-api";
import { Document, Session } from "@/tools/msa/models";

interface Props {
  session: Session;
  document: Document;
}

export default defineComponent<Props>({
  name: "DocumentDropdown",
  props: {
    document: { type: Object, required: true },
    session: { type: Object, required: true }
  },
  setup(props: Props, context) {
    const index = computed(() =>
      props.session.documents.findIndex(current => props.document === current)
    );

    const button = ref<HTMLElement | null>(null);
    const popover = ref<HTMLElement | null>(null);
    const popper = ref<Popper | null>(null);

    const change = ({ document, index }: Record<string, any>) => {
      context.emit("change", { document, index });
      hide();
    };

    const close = (event: Event) => {
      const element = popover.value;

      if (
        element &&
        element.offsetParent &&
        event.target &&
        event.target instanceof Node &&
        !element.contains(event.target)
      )
        hide();
    };

    const hide = () => {
      if (popper.value) {
        popper.value.destroy();
        popper.value = null;
      }

      document.removeEventListener("click", close);
    };

    const show = () => {
      if (!button.value || !popover.value) return;

      popper.value = new Popper(button.value, popover.value, {
        placement: "bottom"
      });

      window.setTimeout(() => {
        document.addEventListener("click", close, true);
      }, 100);

      nextTick(() => {
        if (popper.value) popper.value.update();
      });
    };

    watch(
      () => props.session,
      session => change({ document: session.documents[0], index: 0 }),
      { immediate: true }
    );

    return { index, button, popover, popper, show, change };
  }
});
